<template>
  <div class="row transaction">
    <div
      class="col-12 d-flex align-items-end justify-content-between flex-wrap"
      style="gap: 1rem"
    >
      <div class="form-row align-items-end" style="gap: 0.75rem">
        <div class="">
          <label for="inlineFormInput">Type</label>
          <select class="form-control" v-model="type">
            <option value="">Select Type</option>
            <option value="credit">Credit</option>
            <option value="debit">Debit</option>
          </select>
        </div>
        <div class="">
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="terminalId">Terminal Id</option>
            <option value="walletId">Wallet Id</option>
            <option value="reference">Reference</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'terminalId'">
          <input
            id="inlineFormInputGroup"
            class="form-control"
            v-model="terminalId"
            type="text"
            placeholder="Enter Terminal Id"
          />
        </div>

        <div class="col-auto" v-if="selectedValue === 'walletId'">
          <input
            id="inlineFormInputGroup"
            class="form-control"
            v-model="walletId"
            type="text"
            placeholder="Enter Wallet Id"
          />
        </div>

        <div class="col-auto" v-if="selectedValue === 'reference'">
          <input
            id="inlineFormInputGroup"
            class="form-control"
            v-model="reference"
            type="text"
            placeholder="reference"
          />
        </div>

        <div class="">
          <label>Start Date</label>
          <div class="input-group m-0">
            <input
              type="date"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Start Date"
              v-model="startDate"
            />
          </div>
        </div>

        <div class="">
          <label>End Date</label>
          <div class="input-group m-0">
            <input
              type="date"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="End Date"
              v-model="endDate"
            />
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary m-0"
          @click="refresh('filter')"
        >
          Filter
        </button>

        <button
          type="submit"
          class="btn btn-primary"
          @click="refresh('download')"
        >
          Download
        </button>

        <!-- <h4>Transactions</h4> -->
        <div class="">
          <button class="btn btn-info" @click="refresh('refresh')">
            Refresh
          </button>
        </div>
      </div>

      <div class="col-auto m-0 p-0">
        <router-link
          class="btn btn-info"
          :to="`/dashboard/merchant/request-funds`"
          :style="{ display: isAgent ? 'none' : 'block' }"
        >
          Request Funding
        </router-link>
      </div>
    </div>
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="col-12">
      <div
        class="card-plain"
        style="
          align-items: center;
          justify-content: center;
          display: flex;
          padding: 15px 0;
        "
      >
        <div class="table-full-width table-responsive table-container">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Wallet Id</th>
                <th scope="col" class="text-center">Terminal Id</th>
                <th scope="col" class="text-center">Type</th>
                <th scope="col" class="text-center">Reference</th>
                <th scope="col" class="text-center">Amount</th>
                <th scope="col" class="text-center">Charges</th>
                <th scope="col" class="text-center">VAT on Charge</th>
                <th scope="col" class="text-center">Tax</th>
                <th scope="col" class="text-center">Description</th>
                <th scope="col" class="text-center">Previous Balance</th>
                <th scope="col" class="text-center">New Balance</th>
                <th scope="col" class="text-center">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(hist, index) in history" :key="hist._id">
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>
                <td class="text-center">{{ hist.walletId }}</td>
                <td class="text-center">{{ hist.terminalId }}</td>
                <td class="text-center">
                  <button :class="getTypeClass(hist.type)">
                    {{ hist.type }}
                  </button>
                </td>
                <td class="text-center">{{ hist.reference || null }}</td>
                <td class="text-center">
                  {{ `₦${format.format(hist.amount.toFixed(4))}` }}
                </td>
                <td class="text-center">
                  {{ `₦${hist.charge ? format.format(hist.charge) : 0}` }}
                </td>
                <td class="text-center">{{ `₦${hist.vat || 0}` }}</td>
                <td class="text-center">
                  {{ `₦${hist.tax ? format.format(hist.tax) : 0}` }}
                </td>
                <td class="text-center desc">{{ hist.description }}</td>
                <td class="text-center">
                  {{ `₦${format.format(hist.previousBalance.toFixed(4))}` }}
                </td>
                <td class="text-center">
                  {{ `₦${format.format(hist.newBalance.toFixed(4))}` }}
                </td>
                <td class="text-center">
                  {{ moment(hist.createdAt).format("Y-M-D h:mm:ss a") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="pagination" style="justify-content: space-between; width: 100%">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import fileDownload from "js-file-download";
import { convertArrayToCSV } from "convert-array-to-csv";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      // pagination
      currentPage: 1,
      itemsPerPage: 30,

      error: false,
      history: [],
      errorMsg: "",
      loading: false,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      totalDocs: 0,
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      type: "",
      terminalId: "",
      reference: "",
      walletId: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      selectedValue: "",
      isAgent: localStorage.getItem("userType") === "Merchant",
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    getTypeClass(type) {
      return {
        "text-center": true,
        "type-btn": true,
        credit: type === "credit",
        debit: type === "debit",
      };
    },
    async refresh(mode) {
      try {
        this.loading = true;
        if (mode === "filter" || mode === "refresh") {
          this.page = 1;
          this.currentPage = 1;
        }
        if (mode === "refresh") {
          this.startDate = moment().format("YYYY-MM-DD");
          this.endDate = moment().format("YYYY-MM-DD");
        }
        let payload = {
          page: this.page,
          type: this.type,
          terminalId: this.terminalId,
          walletId: this.walletId,
          startDate: this.startDate,
          endDate: this.endDate,
          reference: this.reference,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/transactions/wallet-reports`,
          payload,
        );
        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.history);
          fileDownload(csvTran, "wallet-report.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.history;
          this.history = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch History";
      }
      this.loading = false;
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/transactions/wallet-reports`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.history;
      this.history = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch History";
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.sn {
  position: absolute;
}
.transaction {
  font-size: 12px;
}
table td,
table th {
  white-space: nowrap;
}
.table-container {
  overflow-x: auto;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
tbody {
  background: #fff !important;
}

.credit {
  background-color: rgb(11, 155, 11);
  color: #fff;
  font-weight: bolder;
}
.debit {
  background-color: rgb(217, 16, 16);
  color: #fff;
  font-weight: bolder;
}
.type-btn {
  padding: 10px 15px !important;
  border: none;
  border-radius: 5px;
}
.desc {
  width: 10px !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}
</style>
